import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ExternalLink } from 'lucide-react';
import './Certification.css';

const Certification = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const certs = [
    {
      title: "AWS Certified Cloud Practitioner",
      issuer: "Amazon Web Services",
      date: "2025",
      image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
      verifyLink: "https://www.credly.com/badges/226b5d51-ae01-4759-b6c2-51e7fba50dbb/public_url",
      color: "#FF9900"
    },
    {
      title: "OCI Foundations Associate",
      issuer: "Oracle",
      date: "2025",
      image: "https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg",
      verifyLink: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=C178F671CD295163D226C6F33A9B974CCDD15DF012F8B774D1EF842F59904B70",
      color: "#C74634"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  return (
    <section id="certifications" ref={ref}>
      <div className="cert-wrapper">
        <motion.div
          className="cert-title"
          initial={{ opacity: 0, y: -20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h3>Certifications</h3>
          <p className="cert-separator" />
          <p className="cert-subtitle">
            Industry-recognized credentials validation.
          </p>
        </motion.div>

        <motion.div
          className="cert-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {certs.map((cert, index) => (
            <motion.div 
              key={index} 
              className="cert-card"
              variants={cardVariants}
              whileHover={{ y: -5 }} // We can safely bring this back now!
            >
              {/* --- THE FIX: INVISIBLE OVERLAY LINK --- */}
              <a 
                href={cert.verifyLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="cert-overlay-link"
                aria-label={`Verify ${cert.title}`}
              />

              <div className="cert-icon-container" style={{ borderColor: `${cert.color}30` }}>
                <img src={cert.image} alt={cert.issuer} className="cert-logo" />
              </div>
              
              <div className="cert-content">
                <h4 className="cert-name">{cert.title}</h4>
                <div className="cert-details">
                  <span className="cert-issuer">{cert.issuer}</span>
                  <span className="cert-dot">•</span>
                  <span className="cert-date">{cert.date}</span>
                </div>
              </div>

              {/* Visual Button Only (User clicks the overlay, not this) */}
              <div className="verify-btn-visual">
                <span className="btn-text">Verify Credential</span>
                <ExternalLink size={16} />
              </div>
              
              <div 
                className="cert-glow" 
                style={{ background: `radial-gradient(circle at 50% 50%, ${cert.color}20 0%, transparent 70%)` }} 
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Certification;